// extracted by mini-css-extract-plugin
module.exports = {"promoitem":"PromoItem_promoitem__2DjhS","promoitem__logo":"PromoItem_promoitem__logo__WDScS"};